import React, {Fragment, useMemo} from 'react';
import {PeopleLoader, Person, usePeople} from '../../person';
import {Membership, MembershipLoader, useMemberships} from '../../membership';
import {query} from '@di-nxt/query';
import {TeamMember} from './types';
import {useSharedErrorHandler} from '../../utils/errorHandlers';

const mapToTeamMember = (
  person: Person,
  membership: Membership,
): TeamMember => {
  const {id, ...otherP} = person;
  const {personId, id: membershipId, ...otherM} = membership;
  const teamMember: TeamMember = {
    personId,
    ...otherP,
    membershipId,
    fullname:
      otherP.firstName && otherP.lastName
        ? `${otherP.firstName} ${otherP.lastName}`
        : undefined,
    display:
      otherP.firstName && otherP.lastName
        ? `${otherP.firstName} ${otherP.lastName}`
        : otherP.mobileNo,
    ...otherM,
    title: 'Courier',
  };

  return teamMember;
};

export const useTeamMembers = (teamId: number) => {
  const memberships = useMemberships({teamId});
  const people = usePeople();
  const members = useMemo(() => {
    return query(people)
      .join(memberships, 'id', 'personId', mapToTeamMember)
      .toArray();
  }, [memberships, people]);

  return members;
};

export const MembersLoader: React.FC<
  Pick<Membership, 'teamId'> & {onError?: (error: Error) => void}
> = ({teamId, onError}) => {
  const sharedOnError = useSharedErrorHandler(onError);
  return (
    <Fragment>
      <MembershipLoader teamId={teamId} onError={sharedOnError} />
      <PeopleLoader teamId={teamId} onError={sharedOnError} />
    </Fragment>
  );
};

export * from './types';
